import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "../components/SEO";
import CTAStrip from "../components/CTAStrip";
import { PRODUCTS, PORTAILS_OVERVIEW } from "../data/products";
import { PRODUCTS_EN, PORTAILS_OVERVIEW_EN } from "../data/products_en";
import { useLang } from "../i18n/LanguageContext";

export default function PortailsOverview() {
    const { lang } = useLang();
    const overview = lang === "en" ? { ...PORTAILS_OVERVIEW, ...PORTAILS_OVERVIEW_EN } : PORTAILS_OVERVIEW;
    const children = PORTAILS_OVERVIEW.children.map((slug) => {
        const p = PRODUCTS[slug];
        const pEn = PRODUCTS_EN[slug] || {};
        return lang === "en" ? { ...p, ...pEn } : p;
    });
    return (
        <>
            <SEO
                title={overview.seoTitle}
                description={overview.seoDescription}
                keywords={["portail Genève", "portail Pays de Gex", "portail Haute-Savoie", "portail sur mesure", "portail aluminium"]}
            />
            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-12">
                <div className="divider-tag mb-6">{overview.title}</div>
                <h1 className="font-display text-4xl md:text-6xl text-white leading-[1.05] tracking-tight max-w-4xl">
                    {overview.title}
                </h1>
                <p className="mt-7 text-white/70 max-w-3xl text-lg leading-relaxed">{overview.intro}</p>
            </section>

            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-20 md:pb-28">
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {children.map((p) => (
                        <Link key={p.slug} to={`/${p.slug}`} className="card-product block group" data-testid={`portails-card-${p.slug}`}>
                            <div className="img-wrap aspect-[4/5]">
                                <img src={p.image} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1118] via-transparent" />
                            </div>
                            <div className="p-5">
                                <div className="text-[10px] tracking-[0.28em] uppercase text-brand-accent/80 mb-1">{p.category}</div>
                                <div className="font-display text-xl text-white group-hover:text-brand-accent transition flex items-center gap-2">
                                    {p.title} <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition" />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

            <CTAStrip />
        </>
    );
}
